module.exports = __webpack_public_path__ + "media/details/conference@1x-7c77f8ea.png";